export class ExcelJsonParametersRequest {
  pJsonParameters: string;
  fileName: string;
}
